import React from 'react';
import { ShieldCheck } from 'lucide-react';

export const HipaaBadge = ({ dark = false, testid = 'portal-hipaa-badge' }) => (
  <span data-testid={testid} title="This practice has a signed HIPAA Business Associate Agreement with The OnCall Bot LLC d/b/a PractCom"
    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold ${dark ? 'bg-emerald-400/15 text-emerald-200 border border-emerald-300/30' : 'bg-emerald-50 text-emerald-800 border border-emerald-200'}`}>
    <ShieldCheck className="w-3.5 h-3.5" /> HIPAA Business Associate Agreement in place
  </span>
);
